import { CompassCardUI } from '@scale/compass-ui/types';
import { DisputeDecision } from '@scale/shared/types/chat/disputes';
import {
  ResolveDisputeCardShared,
  ResolveDisputeSchemaType,
  RESOLVE_DISPUTE,
} from '@scale/genai-compass-shared/cards/resolve_dispute';
import { faCommentsQuestionCheck } from '@fortawesome/pro-solid-svg-icons';
import ResolveDisputesCardComponent from 'react-scale/corp/views/DataCompassCardsV2/action/ResolveDisputesCard/resolveDisputesCardComponent';

export const ResolveDisputesCardInfo: CompassCardUI<ResolveDisputeSchemaType> = {
  ...ResolveDisputeCardShared,
  title: 'Resolve Disputes',
  icon: 'edit',
  toolTip: 'Resolve disputes for tasks',
  defaultContext: {
    cardType: RESOLVE_DISPUTE,
    resolution: DisputeDecision.ACCEPTED,
    selectedDisputeColumn: '',
  },
  ownerTeam: 'Quality',
  button: {
    icon: faCommentsQuestionCheck,
  },
  legacyComponent: ResolveDisputesCardComponent,
};
